__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/8088a88b68e6a0764e409bcc9dd478d077b5edd1/_next/";